/**
 * Варианты цветового решения. Роли цветов везде одинаковые, меняются
 * только значения — поэтому переключение не трогает вёрстку.
 *
 * Сами цвета живут в globals.css, под селектором :root[data-palette='…'].
 * Здесь — только то, что нужно показать человеку: название, пояснение и
 * образцы для кружков.
 */
export const PALETTE_IDS = ['morning', 'pool', 'fuchsia', 'sunset'] as const

export type PaletteId = (typeof PALETTE_IDS)[number]

export const DEFAULT_PALETTE: PaletteId = 'morning'

export type PaletteInfo = {
  id: PaletteId
  name: string
  note: string
  /** образцы: фон, плашка, акцент, тёмная плашка */
  swatch: [string, string, string, string]
}

export const PALETTES: PaletteInfo[] = [
  {
    id: 'morning',
    name: 'Утро',
    note: 'Как сейчас: песок, солнце и бирюза.',
    swatch: ['#f0ddb8', '#ffc531', '#e8457c', '#297a75'],
  },
  {
    id: 'pool',
    name: 'Бассейн',
    note: 'Прохладный бирюзовый фон, жёлтый и розовый — акцентами.',
    swatch: ['#bfe4e0', '#ffcb2e', '#f0417f', '#0f7d86'],
  },
  {
    id: 'fuchsia',
    name: 'Фуксия',
    note: 'Тёплая розовая стена как фон, самый громкий вариант.',
    swatch: ['#f8d6c4', '#ffc81f', '#e8336f', '#5c1430'],
  },
  {
    id: 'sunset',
    name: 'Закат',
    note: 'Охра, терракота и слива — теплее и глубже.',
    swatch: ['#f2cfa2', '#ffb62b', '#ef5f3c', '#3b1d53'],
  },
]

export const isPaletteId = (value: unknown): value is PaletteId =>
  typeof value === 'string' && (PALETTE_IDS as readonly string[]).includes(value)

export const PALETTE_STORAGE_KEY = 'utroclub-palette'
